export const userStatus = Object.freeze({
  ONLINE: 'online',
  OFFLINE: 'offline',
  PAUSE: 'break',
});
